//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            bubbleIndex: 0,
            arrowAlpha: 1,
            pauseSpeechBubble: false,
            showSpeechBubble1: false,
            showSpeechBubble2: false,
            showSpeechBubble3: false,
            showNextButton: false
        };
    },

    computed: {
        nickname () {
            return this.$store.getters.nickname;
        }
    },

    methods: {
        nextSpeechBubble () {
            if (this.bubbleIndex === 0) {
                this.showSpeechBubble1 = true;
                this.bubbleIndex++;
            } else if (this.bubbleIndex === 1) {
                this.showSpeechBubble1 = false;
                this.showSpeechBubble2 = true;
                this.bubbleIndex++;
            } else if (this.bubbleIndex === 2) {
                this.pauseSpeechBubble= true;
                this.showSpeechBubble2 = false;
                this.arrowAlpha = 0;
                this.showSpeechBubble3 = true;
                this.showNextButton = true;
            } 
        }
    }
};
